module.exports = {
	"header.navigation.sports": "Спорт",
	"header.navigation.live": "Тіркелу",
	"header.navigation.cybersport": "Киберспорт",
	"header.navigation.results": "Нәтижелер",
	"header.navigation.fastsport": "Жылдам ойындар",
	"header.navigation.promotions": "Акциялар мен бонустар",
	"header.navigation.more": "Қосымша",
	"header.help": "Көмек",
	"header.locale.choose": "Тілді таңдау:",
	"header.menu.menu_text": "Мәзір",
	"header.menu.company_news": "Компания жаңалықтары",
	"header.menu.regulations": "Ережелер",
	"header.menu.responsible_game": "Масқара ойын",
	"header.menu.contact_information": "Байланыс мәліметтері",
	"header.menu.betting_shop": "Ставкаларды қабылдау орны",
	"header.menu.players_best_bets": "Ойыншылардың ең жақсы ставкалары",
	"header.menu.internet_bonus": "Акциялар мен бонустар",
	"header.menu.privacy_policy": "Жеке мәселелер политикасы",
	"header.user_menu.title": "Профиль",
	"header.user_menu.account_num": "Тіркеу нөмірі",
	"header.user_menu.recharge": "Балансты толтыру",
	"header.user_menu.briefcase": "Ставкалар портфелі",
	"header.user_menu.bet_history": "Ставкалар тарихы",
	"header.user_menu.account_history": "Есеп тарихы",
	"header.user_menu.withdraw": "Балансты алу",
	"header.user_menu.opex_checks": "Чектер «Opex»",
	"header.user_menu.usdt_checks": "Чектер «USD₮»",
	"header.user_menu.profile": "Менің профилім",
	"header.user_menu.bonus": "Бонустар",
	"header.user_menu.logout": "Шығу",
	"header.freebet.title.default": "Сізге {sum}{currency} сомасына тегін ставка (фрибет) қолжетімді\nӘрекеттің басталуы {start}\nӘрекеттің соңы {end}",
	"header.freebet.title.promocode": "Сізге {promocode} промо-коды бойынша {sum}{currency} сомасына тегін ставка (freebet) қолжетімді\nәрекеттің басталуы {start} \nәрекеттің соңы {end}",
	"header.freebet.max_factor": "Максималды коеффициентпен барлық беттерге шашу.",
	"header.freebet.valid_thru": "{startDate} күнінен бастап өтетін уақыт",
	"header.freebet.valid_until": "{expireDate} күнге дейін өтетін уақыт",
	"header.freebet.details": "Фрибет туралы толығырақ",
	"header.games": "Ойындар",
	"header.gamesFromVivo": "Vivo ұсынған ойындар",
	"notification.new_message.new_message": "Жаңа хабарлама",
	"notification.new_message.proceed_to_messages": "Хабарламаларға өту",
	"notification.new_message.close": "Жабу",
	"menu.bookmarks": "Таңдаулы",
	"menu.others": "Басқа",
	"menu.all_sport": "Барлық оқиғалар",
	"menu.popular_sport": "Танымал оқиғалар",
	"menu.calendar": "Кесте",
	"grid.menu.title": "Оқиғалар менюі",
	"grid.menu.collapse_all_events": "Барлық оқиғаларды жию",
	"grid.menu.expand_all_events": "Барлық оқиғаларды көрсету",
	"grid.menu.collapse_all_groups": "Барлық қосымша ставкаларды жию",
	"grid.menu.expand_all_groups": "Барлық қосымша ставкаларды көрсету",
	"grid.menu.display_line_numbers": "Оқиға нөмірлерді көрсету",
	"grid.menu.hide_line_numbers": "Оқиға нөмірлерді жасыру",
	"grid.menu.prematch_filter.title": "Көрсету",
	"grid.menu.prematch_filter.all_time": "Барлық оқиғалар",
	"grid.menu.prematch_filter.next_hour": "Ертеңгі сағат",
	"grid.menu.prematch_filter.next_2_hours": "Келесі 2 сағат",
	"grid.menu.prematch_filter.next_4_hours": "Келесі 4 сағат",
	"grid.menu.prematch_filter.next_6_hours": "Келесі 6 сағат",
	"grid.menu.prematch_filter.next_12_hours": "Келесі 12 сағат",
	"grid.menu.prematch_filter.next_day": "Ертеңгі күн",
	"grid.menu.prematch_filter.next_2_days": "Келесі 2 күн",
	"grid.header.event": "Спорттық ставкалар",
	"grid.header.win1": "П1",
	"grid.header.draw": "X",
	"grid.header.win2": "П2",
	"grid.header.win1_draw": "1X",
	"grid.header.win12": "12",
	"grid.header.draw_win2": "X2",
	"grid.header.handicap": "ФОРА",
	"grid.header.handicap1": "1",
	"grid.header.handicap2": "2",
	"grid.header.under": "МЕН",
	"grid.header.total": "ТОТ",
	"grid.header.over": "БОЛ",
	"grid.header.live_bets_online": " онлайн ставкалар",
	"grid.header.football": "Футболға",
	"grid.header.tennis": "Тенниске",
	"grid.header.cybersport": "Киберспорт",
	"grid.header.hockey": "Хоккей",
	"grid.header.basketball": "Баскетболға",
	"grid.header.voleyball": "Волейболға",
	"grid.header.handball": "Гандболға",
	"grid.header.boxing": "Онлайн боксқа ставка",
	"grid.header.UFC_MMA": "UFC және MMA бойынша онлайн ставкалар",
	"grid.header.american_football": "Американдық футболға онлайн тігу",
	"grid.header.table_tennis": "Үстел теннисіне онлайн ставка жасау",
	"grid.header.live.matches": "Live матчтар",
	"grid.match-current-time.forward": "{minute}'",
	"grid.match-current-time.backward": "артта < {minute}'",
	"grid.match-current-scores.not_started": " Ойын басталмады",
	"grid.match-current-scores.finished": " Ойын аяқталды",
	"grid.match.datetime_at": "в",
	"grid.match.today": "Бүгін",
	"grid.match.tomorrow": "Ертеңгі күн",
	"play.stream.video": "Жатты трансляция бар",
	"login.to.watch": "Көру үшін жүйеге кіруіңіз",
	"timetable.title": "Тіркелген оқиғалар күнтізбесі",
	"timetable.time_filter": "Барлық оқиғалар",
	"timetable.sort_by_time": "Уақыт бойынша сұрыптау",
	"timetable.sort_by_league": "Жатты тақырып бойынша сұрыптау",
	"timetable.matches_filter_menu.title": "Көрсету",
	"timetable.matches_filter_menu.no_filter": "Барлық оқиғалар",
	"timetable.matches_filter_menu.one_hour": "Ертеңгі сағат",
	"timetable.matches_filter_menu.two_hours": "Келесі 2 сағат",
	"timetable.matches_filter_menu.four_hours": "Келесі 4 сағат",
	"timetable.matches_filter_menu.six_hours": "Келесі 6 сағат",
	"timetable.matches_filter_menu.twelve_hours": "Келесі 12 сағат",
	"timetable.matches_filter_menu.one_day": "Ертеңгі күн",
	"timetable.matches_filter_menu.two_days": "Келесі 2 күн",
	"betpanel.title": "Ставкалар",
	"betpanel.help": "Купонға ставка қосу үшін кез-келген шынындай нәтиже бетін басыңыз.",
	"coupon.title": "Жаңа ставка",
	"coupon.make_bet": "Ставка қою",
	"coupon.rate_unavailable": "Коэффициент қол жетімді емес",
	"coupon.stake_title": "Ставка:",
	"coupon.rate_title": "Коэффициент:",
	"coupon.rate_changed": "Коэффициент өзгерді",
	"coupon.confirm_rate_value_change": "Қабылдау",
	"coupon.stake_hint": "Ставка сомасы",
	"coupon.min_amount_hint": "Мин.",
	"coupon.max_amount_hint": "Макс. {amount} {resource}",
	"coupon.bet_type_hint": "Ставка түрі",
	"coupon.total_odd_hint": "Жалпы коэффициент",
	"coupon.possible_winning_hint": "Мүмкін бола табу",
	"coupon.possible_winning_hint_short": "Табыс",
	"coupon.not_possible_stake": "Бұл ставка мүмкін емес",
	"coupon.menu.title": "Ставкалар менюі",
	"coupon.menu.one-click_checkbox": "Бір басумен ставка қою",
	"coupon.menu.one-click_amount": "Ставка сомасы ",
	"coupon.menu.accept_factor_increase": "Коэффициентті көтеруді қабылдау",
	"coupon.menu.accept_factor_decrease": "Коэффициентті төмендетуді қабылдау",
	"coupon.menu.accept_total_and_handicap_change": "Тотал/Фораны өзгертілген ставкаларды қабылдау",
	"coupon.menu.favouriteBets": "Ұнамалы ставкалар",
	"coupon.menu.favouriteBet": "Ставка {num}",
	"coupon.sum_label": "Сомма",
	"coupon_bet_promocode_not_found1": "Промокод табылмады",
	"coupon_bet_for_get_freebet_fill_balance21": "Тегін ставканы алу үшін {amount} {currency} сомасында шотыңызды толтыру қажет",
	"coupon_bet_for_using_freebet_make_stake_more22": "Тегін ставканы пайдалану үшін кем дегенде {amount} {currency} ставкасын қою керек",
	"coupon_bet_for_using_freebet_nessery_auth24": "Тегін ставканы пайдалану үшін есептік жазбаны сәйкестендіру қажет",
	"coupon_bet_for_stake_type32": "Ставка түріне қолданылады: {amount}",
	"coupon_bet_not_for_stake_type37": "Бұл матчқа қолданылмайды",
	"coupon_bet_not_for_the_league38": "Бұл лигаға қолданылмайды",
	"coupon_bet_min_coef_should33": "Ең аз коэффициент болуы керек {amount}",
	"coupon_for_using_freebet_nesessarry_choose_more35": "Тегін ставканы пайдалану үшін кемінде {amount} оқиғаны таңдау керек",
	"coupon_bet_nessary_should_more23": "Ұтыс тігу сомасы {amount} асуы керек",
	"coupon_bet_coef_stakes_changed2": "Ставка тақ өзгертілді",
	"coupon_bet_validation_is_not_accept31": " Промокод тек {value}",
	"coupon_bet_freebet_sum_not_equal_sum_stake36": "Тегін ставка сомасы ставка сомасынан аз/көп",
	"coupon_bet_validation_is_not_accept_by_minCoef34": "тақ {amount} аспауы керек ",
	"bet_type.ordinar": "Ординар",
	"bet_type.accumulator": "Экспресс",
	"bet_type.looseToWinAccumulator": "Антиэкспресс",
	"bet_type.system": "{count} тармақтан {rank}-ші",
	"bet_title.new_bet": "Жаңа ставка",
	"bet_status.not_accepted": "Қабылдалмаған",
	"bet_status.accepted": "Қабылданған",
	"bet_status.canceled": "Болдырылмаған",
	"bet_status.sold": "Сатылған",
	"bet_status.won": "Жеңген",
	"bet_status.lost": "Жоқ кетті",
	"bet_history.refund": "Қайтарым",
	"bet_history.bet_under_consideration": "Растау астында",
	"bet_history.bet_under_consideration_tooltip": "Ставка растау астында. Тағы-тағы-тағы. Ставка растау астында. Тағы-тағы-тағы.",
	"bet_history.sell": "Сату",
	"bet_history.sell_cancel": "Болдырмау",
	"bet_history.cashout_amount_changed": "Сату сомасы өзгерді",
	"bet_history.cashout_confirmation": "Ставканы сатуын растау,{br}сату сомасы",
	"bet_history.event_stake_cashout_forbidden": "Осы оқиға ставка сату тыйым салынды",
	"bet_history.rates_changed": "Коэффициенттер{br}жаңартылды",
	"bet_history.big_stake_cancel": "Ставканы болдырмау",
	"bet_history.rate": "Коэфф: ",
	"bet_history.stake": "Ставка: ",
	"bet_history.errors.insufficient_funds": "Теңгерім жеткізілмеді",
	"bet_history.errors.account_locked": "Сіздің шотыңыз құлыпталды",
	"bet_history.errors.system_not_allowed_for_freebet": "Фрибет ставка түрі 'Система' рұқсат етілмеген",
	"bet_history.errors.incorrect_stake_data": "Ставка деректері дұрыс емес",
	"bet_history.errors.min_stake_amount": "Минималды ставка сомасы {minAmount} {currency}",
	"bet_history.errors.incorrect_virtual_stake": "Виртуалды шоттан дайында ставка деректері дұрыс емес",
	"bet_history.errors.incorrect_freebet_stake": "Фрибет ставкасы деректері дұрыс емес",
	"bet_history.errors.existing_active_stake": "Жүргізілген ставкалар жоқ",
	"bet_history.errors.no_big_stake_permission": "Үлкен ставкалар рұқсат етілмеген",
	"bet_history.errors.freebet_big_stake": "Фрибет ставкасы үлкен болмайды",
	"bet_history.errors.bet_not_accepted_by_terms": "Бұл бонусты пайдалану үшін промокод сипаттамасында көрсетілген шарттарды орындау қажет.",
	"news.read_title": "Оқу",
	"news.company_news": "Компания жаңалықтары",
	"live.error.connection_lost": "Деректер серверімен байланыс жоғалды, күте тұрыңыз рахмет",
	"popular.title": "Танымал спорттық ставкалар",
	"popular.win1": "П1",
	"popular.draw": "Х",
	"popular.win2": "П2",
	"header.signin.join_title": "Тіркеу",
	"header.signin.title": "Кіру",
	"sign_in.phone": "Телефон",
	"sign_in.email": "E-mail",
	"sign_in.login": "Логин",
	"sign_in.or": "немесе",
	"sign_in.title": "Авторизация",
	"sign_in.requisite": "Реквизит",
	"sign_in.password": "Құпия сөз",
	"sign_in.log_in": "Кіру",
	"sign_in.resend_activation": "Жіберу",
	"sign_in.join": "Тіркеу",
	"sign_in.forgot": "Логин немесе құпия сөзді ұмыттымыз ба?",
	"sign_in.activation_sent": "Тіркеуді растау үшін сілтеме сіздің {email} поштанызға жіберілді",
	"sign_in.errors.invalid_credentials": "Жарамсыз логин немесе құпия сөз!",
	"sign_in.errors.user_blocked": "Слишком много попыток. Попробуйте через 15 минут",
	"sign_in.errors.internal": "Қате. Техникалық көмекке хабарласыңыз",
	"sign_in.errors.not_activated": "Сіздің тіркеуіңіз активациялау қамтымас. Активация үшін сілтемені {email} поштанызға қайта жіберу келе ме?",
	"sign_in.errors.wrong_certificate": "Сіздің сертификатыңыз құлыпталды. Техникалық көмекке хабарласыңыз",
	"password_recovery.title": "Шотты қалпына келтіру",
	"password_recovery.sent_to": "Құпия сөзді қалпына келтіру бойынша нұсқаулар <strong>{email}</strong> мекенжайына жіберілді",
	"password_recovery.sent_repeatedly": "Біз сізге қалпына келтіру туралы ақпаратты бірнеше рет жібердік. Қауіпсіздік мақсатында көмек көрсету үшін, техникалық көмекке хабарласыңыз.",
	"password_recovery.sms_exceeded": "Біз сізге құпия сөзді қалпына келтіру туралы хабарлама екі рет жібердік. Өтініш, SMS күтуін күтіңіз немесе техникалық көмекке хабарласыңыз.",
	"password_recovery.delivery_condition": "Егер біздің хатты бес минут ішінде алмасаңыз, онда 'Спам' тізімін тексеріп көріңіз",
	"password_recovery.support": "Егер болмаса, онлайн-жат арқылы клиенттерге көмек көрсету үшін көмек көмегіне хабарласыңыз",
	"password_recovery.registration_requisite": "Сайтта тіркелген уақытында пайдаланған логин, шот, e-mail немесе телефон нөмірін (форматта {mask}) көрсетіңіз",
	"password_recovery.requisite": "Реквизит",
	"password_recovery.recover_title": "Қалпына келтіру",
	"password_recovery.sent_via_sms": "Құпия сөз номеріне <strong>{phone}</strong> жіберілді",
	"password_recovery.support_phone": "Егер бірнеше минут ішінде SMS келмесе, онлайн-жат арқылы клиенттерге көмек көрсету үшін көмек көмегіне хабарласыңыз",
	"password_recovery.errors.invalid_credentials": "Осы тіркеу деректерлерімен пайдаланушы табылмады",
	"password_recovery.errors.internal_error": "Ішкі қате",
	"password_recovery.errors.blocked": "Тым көп сұраулар. 15 минуттан кейін қайталаңыз",
	"footer.fairplay.copyright": "&copy; {year} Букмекерлік компаниясы «Fair Play»",
	"footer.fairplay.copyright_kz": "&copy; {year} «BETtery» ЖШС. «Fair Play» бағдарысы. Лицензия # 320, 23.08.2019",
	"footer.fairplay.copyright_ringobet": "&copy; {year} «TakeBet» ЖШС. «RingoBet» бағдарысы. Лицензия # 34, 12.07.2022",
	"join.fast_registration_title": "Тез тіркеу",
	"join.registration_title": "Стандартты тіркеу",
	"join.title": "Тіркеу",
	"join.login": "Логин",
	"join.password": "Құпия сөз",
	"join.password_repeat": "Құпия сөзді қайталау",
	"join.first_name": "Аты",
	"join.last_name": "Тегі",
	"join.dob": "Туған күні",
	"join.email": "E-mail",
	"join.phone": "Мобильді телефон",
	"join.city": "Қала",
	"join.country": "Ел",
	"join.currency": "Тіркеудің валютасы",
	"join.language": "Тіл",
	"join.timezone": "Уақыт белгісі",
	"join.promo": "Промо-код",
	"join.have_promo": "Промокод бар ма?",
	"join.button_join": "Тіркеу",
	"join.tac_agree": "Мен 18 жаста жасаушымын (Қазақстандықтар үшін +21). Мен <a href=\"{rulesLink}\" target=\"_blank\">Ережелерді</a> толық оқыдым мен оларды толық растамын. Мен сіздің жеке деректерімді орнату өнімдерді пайдалану арқылы өңдеуімен келісемін. Бұл мазмұнда <a href=\"{privacyLink}\" target=\"_blank\">конфиденциалдылық саясаты</a> көрсетілген",
	"join.real_info_warning": "Ескертпе! Жасырын деректерді енгізіп отырып, толтырылған шоттан аударуымызды қарап тұр. Менің атауым мен тегімім регистрациядан кейін өзгертілмейді.",
	"join.link_sent_to": "Растау үшін сілтеме {email} поштанызға жіберілді",
	"join.fast.type": "Тіркеу",
	"join.fast.type.sms": "SMS",
	"join.fast.type.email": "E-mail",
	"join.fast.phone": "Телефон номері",
	"join.fast.email": "E-mail",
	"join.fast.currency": "Валюта",
	"join.fast.button_join": "Тіркеу",
	"join.fast.tac_agree": "Түймені басу арқылы сіз <a href={rulesLink} target='_blank'>компания ережелерімен</a>, <a href={privacyLink} target='_blank'>құпиялылық саясатымен</a> келісесіз, және жасыңыз 21 жастан асқанын растайсыз.",
	"join.fast.tac_agree_ringo": "Түймені басу арқылы сіз <a href={rulesLink} target='_blank'>компания ережелерімен</a>, <a href={privacyLink} target='_blank'>құпиялылық саясатымен</a> келісесіз, және жасыңыз 21 жастан асқанын растайсыз.",
	"join.fast.phone_confirm.title": "Телефон номерін растау",
	"join.fast.phone_confirm.confirm_button": "Растау",
	"join.fast.phone_confirm.confirmation_code": "Растау коды",
	"join.fast.phone_confirm.sms_received_text": "Сізге SMS арқылы растау коды жіберілді. Телефон номеріні растау үшін оны қолданыңыз. SMS жеткізу уақыты бір минуттан көп болуы мүмкін.",
	"join.fast.phone_confirm.sms_sent_text": "Хабарлама жіберілді. ",
	"join.fast.phone_confirm.sms_resendinfo_text": "Қайталау мүмкіндігі {seconds} секундтан кейін. ",
	"join.fast.phone_confirm.call_resendinfo_text": "Қайталау мүмкіндігі {seconds} секундтан кейін.",
	"join.fast.phone_confirm.sms_resend_text": "Хабарламаны қайталау",
	"join.fast.phone_confirm.call_resend_text": "Растау сұрауын қайталау",
	"join.fast.phone_confirm.sms_resend_button_text": "Жіберу",
	"join.fast.phone_confirm.call_resend_button_text": "Сұрау жасау",
	"join.fast.success.text": "Сіздің шоты сәтті арттырылды!",
	"join.fast.success.recharge_text": "Ойын бастау үшін балансты толтырып алыңыз",
	"join.fast.success.btn_recharge_text": "Балансты толтыру",
	"join.errors.internal": "Қате. Кейінірек өтіңіз",
	"join.errors.smsexceeded": "Сізге шотты растау үшін хабарлама екі рет жіберілді. SMS келмеді дайын емес, жаттығу электрондық поштамен растау жайлы ақпаратты жіберіп отамыз.",
	"join.errors.login_taken": "Логин қазірдің өзінде қолданыста",
	"join.errors.email_taken": "E-mail қазірдің өзінде қолданыста",
	"join.errors.phone_taken": "Телефон қазірдің өзінде қолданыста",
	"join.errors.phone_not_found": "Телефон нөмірі дұрыс емес",
	"join.errors.required_field": "Толтыру қажет",
	"join.errors.promo_length_error": "Ең көп 4 белгі",
	"join.errors.login_requirements": "Ең аз 4 белгі, тек латын әліпбиі мен сандар",
	"join.errors.passwords_not_equal": "Құпия сөздер сәйкес келмейді",
	"join.errors.email_invalid": "E-mail дұрыс емес",
	"join.errors.invalid_promo": "Дұрыс емес промо-код",
	"join.errors.phone_invalid": "Телефон номері дұрыс көрсетілмеген",
	"join.errors.age_incorrect": "Туған күні дұрыс көрсетілмеген",
	"join.errors.age_illegal": "Құпияныс",
	"join.errors.date_invalid": "Туған күні дұрыс көрсетілмеген",
	"join.password_changed": "Құпия сөз өзгертілді",
	"join.fast.phone_confirm.errors.confirmation_fail": "Растау кезінде қате пайда болды",
	"join.fast.phone_confirm.errors.sms_exceeded": "Сізге шотты растау үшін хабарлама екі рет жіберілді. SMS келмеді дайын емес, жаттығу электрондық поштамен растау жайлы ақпаратты жіберіп отамыз.",
	"join.fast.phone_confirm.errors.invalid_code": "Дұрыс емес код",
	"phone_confirm.title": "Телефон нөмірін растау",
	"phone_confirm.phone": "Мобильді телефон",
	"phone_confirm.sms_text": "Бұл нөмірге растау кодымен SMS жіберіледі",
	"phone_confirm.confirm_button": "Растау",
	"phone_confirm.denial": "Мен жеңілдікте қатысу үшін телефон номерімді растаушымын, тек мені регистр тіркеу",
	"phone_confirm.conditions": "Өзгерістерге қатысу үшін мобильді телефон номерін растау керек",
	"phone_confirm.confirmation_code": "Растау коды",
	"phone_confirm.sms_received_text": "SMS хабарламасынан келген кодты енгізіңіз, {phone} номерге жіберілді",
	"phone_confirm.success": "{phone} номер сәтті расталды!",
	"phone_confirm.start_playing": "Ойнау бастау",
	"phone_confirm.errors.confirmation_fail": "Растау кезінде қате пайда болды",
	"phone_confirm.errors.phone_taken": "Телефон номері бұрыннан қолданылды",
	"phone_confirm.phone_hint": "Мемлекеттік префикс пайдаланыңыз",
	"special_offers.site146_proposal": "Сіздікі промо-код «Жаттыру бонус - 1000 теңге!» акциясына қатысызды қамтамасыз етеді.<br /> Бонусты алу үшін мобильді телефон номерін растау керек",
	"special_offers.site146_accepted": "Сіздікі ойын тіркемесі «Жаттыру бонус - 1000 теңге!» акциясына қатысызды қамтамасыз етеді",
	"pages.main.title": "Онлайн спорт параулары. Қазақстандағы FairPlay тотализаторы.",
	"pages.main.description": "Күні бойы көбірек спорт іс-шараларына жарнамаларды өткіземіз: футбол, теннис, баскетбол, волейбол, хоккей, бокс, күрес, салу, шұғылды, шұғылды жаттыру.",
	"pages.live.title": "FairPlay көп салмақты спорттык тотализаторды онлайн ойнау",
	"pages.live.description": "FairPlay букмекерлік компаниясының веб-сайтының Live ставкалары мен оңай интерфейсі көмек көрсету үшін көбірек ставкаларды таңдауға мүмкіндік береді.",
	"pages.sports.title": "Онлайн тотализатор №1 Қазақстанда - FairPlay",
	"pages.sports.description": "Онлайн ставка қою өте оңай - сізді қызықтыратын спорттық іс-шараны көрсетіңіз, қажетті нәтижені таңдаңыз және ставка соммасын енгізіңіз. Ендіден бастап пари жасау!",
	"pages.timetable.title": "Спорт трансляциялары. Келесі ойындар кестесі.",
	"pages.timetable.description": "Тотализаторлық ставкалар үшін мүмкін болатын спорттық іс-шаралардың онлайн трансляциялары тізімі.",
	"betpanel.unauth.how_to_bet": "Ставка қалай ойнау?",
	"betpanel.unauth.to_configure_coupon": "Купонды баптау үшін - ",
	"betpanel.unauth.auth_or_register": "{signTrigger} немесе {joinTrigger}, мәліметтерді толтырып, тіркеусіз.",
	"betpanel.unauth.time_to_bet": "Ставка ойнау уақыт!",
	"betpanel.unauth.sign_trigger": "Кіру",
	"betpanel.unauth.join_trigger": "тіркелу",
	"betpanel.unauth.to_place_bet": "Ставка ойнау үшін - ",
	"betpanel.unauth.should_auth": "кіру",
	"betpanel.unauth.should_register": "тіркеліңіз",
	"betpanel.unauth.auth_or_register_to_bet": "{signTrigger} немесе {joinTrigger}",
	"timezones.item_1": "Азия/Алматы",
	"timezones.item_2": "Еуропа/Мәске",
	"create-password.modla-title": "Парольді көрсетіңіз",
	"create-password.profile_password_form_new_password_label": "Жаңа құпия сөз",
	"create-password.profile_password_form_retype_password": "Құпия сөзді қайталау",
	"create-password.profile_password_form_btn_msg": "Сақтау",
	"create-password.limit_form_error_empty_field": "Мәліметті толтыру міндетті",
	"create-password.password_form_error_mismatch": "Құпия сөзді растау сәйкес келмейді",
	"create-password.password_changed": "Құпия сөз өзгертілді",
	"betgames.disclaimer1": "BetGamesTV үшін ойнау тегін жаттығу келген жаңа ойындарға негізделген. Бұл ойынды онлайн-казино болмаса да, «Ойын ісі» туралы Заңды «оқиға ойын» категориясына жатамайды.",
	"betgames.disclaimer2": "БК «Fair Play» даналық ойындарды организациялау жатамайды және өзі ойын ісінде болмайды, қатар онда паришатқыштар (ойыншылар) әрекет етпейді. Осы түрдегі жаңа ойындарды органайтын компания «TV ZAIDIMAI» болып табылады. Ойындардың өткендігі ойша жатамайды, БК «Fair Play» не ойша көтерушінің немесе паришатқыштың (ойыншының) өткендігінің байланысқысыздығымен жасалады. Ойындардың нәтижелеріні компания «TV ZAIDIMAI» өзі қалпына салады және оларды оның ресми веб-сайтында жариялауы мүмкін.",
	"games.virtual-sport": "Виртуалды спорт",
	"games.auth-required": "Тіркелу қажет",
	"games.vivo_games": "Live казино - рулетка, покер, блэкджек, баккара...",
	"games.red_rake": "Слоттар, Бинго, Покер, Рулетка",
	"games.leap_gaming": "Виртуалды спорт, Жарыс, Слоттар",
	"games.vivo_slots": "Ойындардың слот автоматтары",
	"games.tv_bet": "ТВ-ойындар - блэкджек, покер, кено, тақтаса...",
	"games.fastsport": "Жылдам спорт",
	"games.tv_bet_roullette": "Рулетка Live",
	"games.xpress": "Слоты, казино, лайв-игры",
	"games.back_to_games": "Ойындар тізіміне қайта оралу",
	"games.back_to_slots": "Слот-ойындарды тізіміне қайта оралу",
	"games.new": "Жаңалықтар",
	"games.more": "Қосымша 20 ойын",
	"games.all_slots": "Барлық слоттар",
	"games.gamesSlots": "Ойын автоматтары",
	"games.sport_vfl": "Футбол лигасы",
	"games.sport_vfcc": "Футбол Жеңімпаздар Кубогы",
	"games.sport_vfwc": "Футбол Жаңа Жаңбыр",
	"games.sport_vfc": "Футбол Жеңімпаздар Кубогы 2020",
	"games.sport_vfac": "Футбол Азия Кубогы",
	"games.sport_vbl": "Баскетбол лигасы",
	"verify_form.title": "Суреттерді жүктеп алып немесе айналдырып көрсетіңдер. Құжаттың барлық жағы беті кадрға жатуы керек, ақпарат оқи болуы тиіс.",
	"verify_form.available_files": "Рұқсат етілген файлдар: image/jpeg, image/png",
	"verify_form.max_file_size": "Өлшемі: 20.00 МБ-дан асқан болмауы керек",
	"verify_form.document_front_side": "Құжаттың алдындағы жағы",
	"verify_form.document_back_side": "Құжаттың артындағы жағы",
	"verify_form.selfie_with_document": "Селфи документпен",
	"verify_form.submit": "Жіберу",
	"promocode.error.not_found": "Промокод табылмады",
	"promocode.error.not_active": "Промокод қолданылмайды",
	"promocode.error.used": "Промокод қолданылдган",
	"promocode.error.not_available": "Промокод қолданылмайды",
	"promocode.title": "Жарнамалық код",
	"promocode.tab": "Жарнамалық кодтар",
	"promocode.enter": "Жарнамалық код енгізіңіз",
	"promocode.apply": "Қолдану",
	"instagram.banner.iphone_title": "ГЛАВНЫЙ ПРИЗ",
	"instagram.banner.freebet_text": "РОЗЫГРЫШ ФРИБЕТОВ",
	"instagram.banner.center_text": "Акция в инстаграм",
	"newGames.showAllGames": "Посмотреть все игры",
	"newGames.showRecentGames": "Посмотреть недавние игры",
	"newGames.showFavorites": "Посмотреть избранные игры"
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/localization/kk.json
// module id = 1831
// module chunks = 2